module.exports = __webpack_public_path__ + "static/media/Iconly-Light-Logout.d03fb905.svg";